import { combineReducers } from 'redux';
import {
  GET_PERMISSION,
  GET_PERMISSION_SUCCESS
} from "../action-types/userInfo";

const permissionList = (state = {}, action) => {
  if (action.type === GET_PERMISSION) {//添加flag字段，作为是否权限返回，对应展示空白页
    return { ...state, flag: false }
  } else if (action.type === GET_PERMISSION_SUCCESS) {
    return { ...state, ...action.data, flag: true }
  }
  return state
}

export default combineReducers({
  permissionList
})
